import React, { useMemo } from 'react';

import { EFaktura } from '../../generated-types';
import useTranslation, { formatJsx } from '../../hooks/useTranslation';

type Props = {
    eFakturas: EFaktura[];
    formattedTotalAmount: string;
};

const MultipleEFakturaApprovalText: React.FC<Props> = ({ eFakturas, formattedTotalAmount }) => {
    const { approveMultipleEFaktura: approveMultipleEFakturaText } = useTranslation();

    const numOfSharedEFaktura = useMemo(() => eFakturas.filter((eFaktura) => !!eFaktura.owner).length, [eFakturas]);

    if (numOfSharedEFaktura > 0)
        return (
            <span>
                {formatJsx(
                    approveMultipleEFakturaText.youAreApprovingNEFakturasWithSharedAtOnce,
                    <span className="bold">{eFakturas.length}</span>,
                    <span className="bold">{numOfSharedEFaktura}</span>,
                    <span className="bold">{formattedTotalAmount}</span>,
                )}
            </span>
        );

    return (
        <span>
            {formatJsx(
                approveMultipleEFakturaText.youAreApprovingNEFakturasAtOnce,
                <span className="bold">{eFakturas.length}</span>,
                <span className="bold">{formattedTotalAmount}</span>,
            )}
        </span>
    );
};

export default MultipleEFakturaApprovalText;
